<template>
  <v-app id="app">
    <component :is="layout">
      <router-view />
    </component>
  </v-app>
</template>

<script>
import { Api } from "@/core/api.js";

import router from "./router";
import Vue from "vue";
import VueGtag from "vue-gtag";
// import VueAnalytics from "vue-analytics";
const api = new Api();
const default_layout = "default";

const isProd = process.env.NODE_ENV == "production";

// Vue.use(VueAnalytics, {
//   id: "UA-149877352-1",
//   router,
//   debug: {
//     enabled: !isProd,
//     sendHitTask: isProd
//   }
// });

Vue.use(
  VueGtag,
  {
    config: { id: "G-MLKVDTTGR0" }
  },
  router
);

export default {
  computed: {
    layout() {
      var layout =
        typeof this.$route.meta.layout !== "undefined"
          ? this.$route.meta.layout
          : default_layout;
      return layout + "-layout";
    }
  },
};
</script>

<style lang="scss"></style>
